<nz-card [nzTitle]="'agentBuilder.title'|translateTA" [nzExtra]="cardExitTemplate" [nzLoading]="loading">
  <div class="agente-layout">

    <!-- Navegacao lateral: com dez passos, a barra horizontal espremia os
         titulos e escondia a legenda de cada um. Na vertical cabe o titulo
         inteiro e o "pronto / pendente" ao lado. -->
    <aside class="passos-lateral">

        <div class="passos-grupo-titulo">{{'agentBuilder.group.build'|translateTA}}</div>

        <nz-steps nzDirection="vertical" nzSize="small"
            [nzCurrent]="passoAtual"
            (nzIndexChange)="irParaPasso($event)">
            @for (item of passosDoGrupo('montar'); track item.passo.chave) {
                <nz-step
                    [nzTitle]="item.passo.titulo|translateTA"
                    [nzSubtitle]="legendaDoPasso(item.indice)|translateTA"
                    [nzStatus]="statusDoPasso(item.indice)">
                </nz-step>
            }
        </nz-steps>

        <div class="passos-grupo-titulo">{{'agentBuilder.group.follow'|translateTA}}</div>

        <!-- nzStartIndex mantem a numeracao continua: sem ele o segundo grupo
             recomecaria em 1 e o clique levaria ao passo errado -->
        <nz-steps nzDirection="vertical" nzSize="small"
            [nzCurrent]="passoAtual"
            [nzStartIndex]="6"
            (nzIndexChange)="irParaPasso($event)">
            @for (item of passosDoGrupo('acompanhar'); track item.passo.chave) {
                <nz-step
                    [nzTitle]="item.passo.titulo|translateTA"
                    [nzSubtitle]="legendaDoPasso(item.indice)|translateTA"
                    [nzStatus]="statusDoPasso(item.indice)">
                </nz-step>
            }
        </nz-steps>

    </aside>

    <div class="passo-conteudo">

        @if (passoAtual === 0) {
            <form nz-form [formGroup]="form" nzLayout="horizontal" nzLabelAlign="right" [nzLayout]="'vertical'">
                <nz-form-item >
                    <nz-form-label>{{'agentBuilder.agentname' | translateTA}}</nz-form-label>
                    <nz-form-control>
                        <input nz-input formControlName="agentName">
                    </nz-form-control>
                </nz-form-item>

                <div nz-row [nzGutter]="8">
                    <div nz-col [nzSpan]="12">
                        <nz-form-item>
                            <nz-form-label>Stream</nz-form-label>
                            <nz-form-control>
                                <nz-switch formControlName="stream"></nz-switch>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="12">
                        <nz-form-item>
                            <nz-form-label>{{'agentBuilder.autonomo'| translateTA}}</nz-form-label>
                            <nz-form-control>
                                <nz-switch formControlName="autonomo"></nz-switch>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>

                <!-- Vale para qualquer agente, autonomo ou nao: e o interruptor
                     geral, que suspende o agente sem apagar nada -->
                <nz-form-item>
                    <nz-form-label>{{'agentBuilder.active'| translateTA}}</nz-form-label>
                    <nz-form-control [nzExtra]="'agentBuilder.active.hint'|translateTA">
                        <nz-switch formControlName="active"></nz-switch>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label>{{'agentbuilder.codecontract' | translateTA}}</nz-form-label>
                    <nz-form-control>
                        <search-input-new [searchProperties]="searchInputCodeContract" (onChangeData)="onChangeCodeCodeContract($event)" class="full-width" formControlName="codecontract"></search-input-new>
                        <!--input nz-input formControlName="codecontract"-->
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label>{{'agentbuilder.codecompany' | translateTA}}</nz-form-label>
                    <nz-form-control>
                        <!--input nz-input formControlName="codecompany"-->
                        <search-input-new [searchProperties]="searchInputCodeCompany"  [variables]="variables" [changes]="changeCodeContract"  class="full-width" formControlName="codecompany"></search-input-new>
                    </nz-form-control>
                </nz-form-item>
                <!-- O tamanho do vetor vem do modelo de embedding, e o indice do
                     Mongo foi criado com esse tamanho. Trocar depois nao da erro:
                     a busca so para de achar conteudo. -->
                @if (embeddingTravado) {
                    <nz-alert nzType="info" nzShowIcon class="embedding-travado"
                        [nzMessage]="'agentBuilder.embeddingLocked'|translateTA"
                        [nzDescription]="'agentBuilder.embeddingLocked.hint'|translateTA">
                    </nz-alert>
                }

                <nz-form-item >
                    <nz-form-label>{{'agentBuilder.llm' | translateTA}} ( Large Language Model )</nz-form-label>
                    <nz-form-control>
                        <nz-select formControlName="llm"  [nzCustomTemplate]="selectedValueTemplate">
                            @for ( model of (modelsData|async); track model) {
                                 <nz-option [nzValue]="model.llm" nzCustomContent [nzLabel]="model.name">
                                    <nz-icon [nzType]="model.icon"></nz-icon>
                                    {{model.name}}
                                 </nz-option>
                            }   
                        </nz-select>
                        <ng-template #selectedValueTemplate let-selected>
                            @let dataOption = getModel(selected.nzValue);
                             <nz-icon [nzType]="dataOption.icon"></nz-icon>
                            {{ selected?.nzLabel }}
                        </ng-template>

                    </nz-form-control>
                </nz-form-item>

                <!-- So o provedor llama monta a URL a partir daqui; para OpenAI e
                     Gemini o endereco e fixo no SDK e o campo confundiria -->
                @if (precisaDeBaseUrl) {
                    <nz-form-item>
                        <nz-form-label nzRequired>{{'agentBuilder.baseUrl' | translateTA}}</nz-form-label>
                        <nz-form-control [nzErrorTip]="'agentBuilder.baseUrl.required'|translateTA"
                                         [nzExtra]="'agentBuilder.baseUrl.hint'|translateTA">
                            <input nz-input formControlName="baseUrl" placeholder="http://localhost:11434/v1">
                        </nz-form-control>
                    </nz-form-item>
                }

                <nz-form-item>
                    <nz-form-label>{{'agentBuilder.model' | translateTA}}</nz-form-label>
                    <nz-form-control>
                        <nz-select formControlName="model">
                            @for ( model of models; track model) {
                                <nz-option [nzValue]="model" [nzLabel]="model"></nz-option>
                            }   
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label>Embed Model</nz-form-label>
                    <nz-form-control>
                        <!-- o catalogo aceita string ou { name, dimensions }; o valor
                             gravado no agente e sempre o nome -->
                        <nz-select formControlName="embeedModel">
                            @for ( model of embeedModels; track nomeDoEmbedding(model)) {
                                <nz-option [nzValue]="nomeDoEmbedding(model)" [nzLabel]="nomeDoEmbedding(model)"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label>API Key</nz-form-label>
                    <nz-form-control>
                        <input nz-input type="password" formControlName="apiKey">
                    </nz-form-control>
                </nz-form-item>

                <nz-row [nzGutter]="16">
                    <nz-col nzSpan="6">
                        <nz-form-item>
                            <nz-form-label>{{'agentBuilder.temperature'|translateTA}}</nz-form-label>
                            <nz-form-control>
                                <input nz-input type="text" formControlName="temperature">
                            </nz-form-control>
                        </nz-form-item>
                    </nz-col>
                    <nz-col nzSpan="6">
                        <nz-form-item>
                            <nz-form-label>{{'agentBuilder.maxTokens'|translateTA}}</nz-form-label>
                            <nz-form-control>
                                <input nz-input type="number" formControlName="maxTokens">
                            </nz-form-control>
                        </nz-form-item>
                    </nz-col>
                    <nz-col nzSpan="6">
                        <nz-form-item>
                            <nz-form-label>{{'agentBuilder.topP'|translateTA}}</nz-form-label>
                            <nz-form-control>
                                <input nz-input type="number" formControlName="topP">
                            </nz-form-control>
                        </nz-form-item>
                    </nz-col>
                </nz-row>
                    
                <nz-divider nzPlain nzVariant="solid" nzText="{{'agentBuilder.databaseconfiguration' | translateTA}}"></nz-divider>

                <nz-form-item>
                    <nz-form-label>{{'agentBuilder.databasename' | translateTA}}</nz-form-label>
                    <div class="item-form-group">
                        <nz-form-control>
                        <!--input nz-input formControlName="dbName"-->
                            <search-input-new [searchProperties]="searchDBNAME" class="full-width" formControlName="dbName" [variables]="variables" [changes]="changeCodeContract"
                            (onSelect)="onDatabaseSelect($event)"></search-input-new>
                        </nz-form-control>
                        <button nz-button nzType="primary"  (click)="createDatabase()" nz-tooltip  [nzTooltipTitle]="'agentBuilder.createdatabasename'|translateTA">
                                <nz-icon nzType="database" nzTheme="outline"></nz-icon>
                        </button>
                    </div>
                </nz-form-item>
                <nz-collapse nzBordered="true" class="card-board" >
                    <nz-collapse-panel nzcoll nzHeader="{{'agentBuilder.databaseconfiguration.advanced' | translateTA}}" [nzDisabled]="form.get('dbName').value == null || form.get('dbName').value == ''" [nzActive]="false">
                    
                        <nz-row [nzGutter]="16">
                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>QA Table</nz-form-label>
                                <nz-form-control>
                                    <input nz-input formControlName="qaTable">
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>Log Autonumus Table</nz-form-label>
                                <nz-form-control>
                                    <input nz-input formControlName="alTable">
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>Feedback Table</nz-form-label>
                                <nz-form-control>
                                    <input nz-input formControlName="fbTable">
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>FeedBack Vector Index</nz-form-label>
                                <nz-form-control>
                                    <input nz-input formControlName="fbVectorIndexName">
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>KB Table</nz-form-label>
                                <nz-form-control>
                                    <input nz-input formControlName="kbTable">
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>KB Vector Index Name</nz-form-label>
                                <nz-form-control>
                                    <input nz-input formControlName="kbVectorIndexName">
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                        </nz-row>           
                    </nz-collapse-panel>     
                    

                    <!-- Limites de execucao: protegem contra o agente ficar rodando
                         ferramenta sem parar e contra a conversa longa estourar a
                         janela do modelo. O Java assume os mesmos padroes quando o
                         campo vem vazio. -->
                    <nz-collapse-panel nzHeader="{{'agentBuilder.limits' | translateTA}}" [nzActive]="false">
                        <nz-row [nzGutter]="16">

                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>{{'agentBuilder.maxToolIterations'|translateTA}}</nz-form-label>
                                <nz-form-control [nzExtra]="'agentBuilder.maxToolIterations.hint'|translateTA">
                                    <nz-input-number formControlName="maxToolIterations" [nzMin]="1" [nzMax]="50" [nzStep]="1" class="full-width"></nz-input-number>
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>{{'agentBuilder.maxHistoryMessages'|translateTA}}</nz-form-label>
                                <nz-form-control [nzExtra]="'agentBuilder.maxHistoryMessages.hint'|translateTA">
                                    <nz-input-number formControlName="maxHistoryMessages" [nzMin]="2" [nzMax]="500" [nzStep]="10" class="full-width"></nz-input-number>
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                            <!-- O que fazer com o trecho que passa do limite acima:
                                 resumir custa uma chamada extra ao modelo, mas so
                                 quando o corte acontece -->
                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>{{'agentBuilder.resumirHistorico'|translateTA}}</nz-form-label>
                                <nz-form-control [nzExtra]="'agentBuilder.resumirHistorico.hint'|translateTA">
                                    <nz-switch formControlName="resumirHistorico"></nz-switch>
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                        </nz-row>
                    </nz-collapse-panel>

                    <!-- Quanto conteudo cada busca traz. Estava dentro do painel de
                         banco de dados, onde ninguem procura por isso - e ficava
                         inacessivel enquanto o dbName estivesse vazio. -->
                    <nz-collapse-panel nzHeader="{{'agentBuilder.search' | translateTA}}" [nzActive]="false">

                        <p class="prompt-builder-section-hint">{{'agentBuilder.search.hint'|translateTA}}</p>

                        <nz-row [nzGutter]="16">

                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>{{'agentBuilder.ragTopK'|translateTA}}</nz-form-label>
                                <nz-form-control [nzExtra]="'agentBuilder.ragTopK.hint'|translateTA">
                                    <nz-input-number formControlName="ragTopK" [nzMin]="1" [nzMax]="100" [nzStep]="1" class="full-width"></nz-input-number>
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>{{'agentBuilder.ragMinScore'|translateTA}}</nz-form-label>
                                <nz-form-control [nzExtra]="'agentBuilder.ragMinScore.hint'|translateTA">
                                    <nz-input-number formControlName="ragMinScore" [nzMin]="0" [nzMax]="1" [nzStep]="0.05" class="full-width"></nz-input-number>
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                            <!-- Limite proprio do documento anexado na conversa: o arquivo
                                 que o usuario acabou de enviar costuma precisar ser lido
                                 por inteiro, ao contrario da base de conhecimento geral -->
                            <nz-col nzSpan="12">
                                <nz-form-item>
                                <nz-form-label>{{'agentBuilder.ragTopKUserDoc'|translateTA}}</nz-form-label>
                                <nz-form-control [nzExtra]="'agentBuilder.ragTopKUserDoc.hint'|translateTA">
                                    <nz-input-number formControlName="ragTopKUserDoc" [nzMin]="1" [nzMax]="200" [nzStep]="5" class="full-width"></nz-input-number>
                                </nz-form-control>
                                </nz-form-item>
                            </nz-col>

                        </nz-row>
                    </nz-collapse-panel>

                    <!-- Quais contextos o agente busca a cada pergunta, e em que ordem.
                         Cada etapa desligada poupa um embedding e uma busca no banco. -->
                    <nz-collapse-panel nzHeader="{{'agentBuilder.pipeline' | translateTA}}" [nzActive]="false">

                        <p class="prompt-builder-section-hint">{{'agentBuilder.pipeline.hint'|translateTA}}</p>

                        <!-- A ordem e a de execucao: a ultima etapa ligada fica colada
                             na pergunta e pesa mais na resposta -->
                        @for (etapa of etapasOrdenadas; track etapa.chave) {
                            <div class="pipeline-etapa" [class.pipeline-desligada]="etapa.posicao === 0">

                                <div class="pipeline-linha">

                                    @if (etapa.posicao > 0) {
                                        <span class="pipeline-posicao">{{etapa.posicao}}</span>
                                    } @else {
                                        <span class="pipeline-posicao pipeline-posicao-off">-</span>
                                    }

                                    <label nz-checkbox
                                        [ngModel]="etapa.posicao > 0"
                                        [ngModelOptions]="{standalone: true}"
                                        (ngModelChange)="alternarEtapa(etapa.chave)">
                                        {{etapa.titulo|translateTA}}
                                    </label>

                                    <span class="pipeline-acoes">
                                        <button nz-button nzType="text" nzSize="small"
                                            [disabled]="etapa.posicao <= 1"
                                            nz-tooltip [nzTooltipTitle]="'agentBuilder.pipeline.up'|translateTA"
                                            (click)="moverEtapa(etapa.chave, -1)">
                                            <nz-icon nzType="arrow-up"></nz-icon>
                                        </button>
                                        <button nz-button nzType="text" nzSize="small"
                                            [disabled]="etapa.posicao === 0 || etapa.posicao === quantidadeLigadas"
                                            nz-tooltip [nzTooltipTitle]="'agentBuilder.pipeline.down'|translateTA"
                                            (click)="moverEtapa(etapa.chave, 1)">
                                            <nz-icon nzType="arrow-down"></nz-icon>
                                        </button>
                                    </span>

                                </div>

                                <span class="pipeline-ajuda">{{(etapa.titulo + '.hint')|translateTA}}</span>
                            </div>
                        }

                        @if (quantidadeLigadas > 1) {
                            <p class="pipeline-rodape">{{'agentBuilder.pipeline.orderHint'|translateTA}}</p>
                        }

                    </nz-collapse-panel>
                </nz-collapse>
            </form>
            @if (form.get('autonomo')?.value == true){
                    <nz-divider nzPlain nzVariant="solid" nzText="{{'agentBuilder.autonomoConfiguration' | translateTA}}"></nz-divider>
                    <form  nz-form [formGroup]="form" nzLayout="horizontal" nzLabelAlign="right" [nzLayout]="'vertical'">

                        <!-- Os dois campos que o loadAgents do Java exige para carregar o
                             agente. Sem eles o ciclo autonomo nunca enxerga este agente,
                             por mais que o cron esteja certo. -->
                        <nz-form-item>
                                <nz-form-label nzRequired>{{'agentBuilder.servername'| translateTA}}</nz-form-label>
                                <nz-form-control [nzErrorTip]="'agentBuilder.servername.required'|translateTA"
                                                 [nzExtra]="'agentBuilder.servername.hint'|translateTA">
                                    <nz-select formControlName="servername" class="full-width"
                                        [nzPlaceHolder]="'agentBuilder.servername.placeholder'|translateTA">
                                        @for ( servidor of servidores; track servidor.HOSTNAME ) {
                                            <nz-option [nzValue]="servidor.HOSTNAME"
                                                       [nzLabel]="servidor.NAME ? servidor.NAME + ' (' + servidor.HOSTNAME + ')' : servidor.HOSTNAME"></nz-option>
                                        }
                                    </nz-select>
                                </nz-form-control>
                        </nz-form-item>

                        <nz-form-item>
                                <nz-form-label>{{'agentBuilder.maxIterator'| translateTA}}</nz-form-label>
                                <nz-form-control>
                                    <input nz-input type="number" formControlName="maxIterator">
                                </nz-form-control>
                        </nz-form-item>
                         <nz-form-item>
                                <nz-form-label nzRequired>{{'agentBuilder.cron'| translateTA}}</nz-form-label>
                                <nz-form-control [nzErrorTip]="'agentBuilder.cron.required'|translateTA"
                                                 [nzExtra]="'agentBuilder.cron.hint'|translateTA">

                                    <nz-space-compact [style.width.%]="100">
                                        <input #inputValue nz-input formControlName="cron"  [placeholder]="'agentBuilder.cron'|translateTA" [type]="'text'"/>
                                        <button nz-button nzType="primary" nzSearch (click)="openScheduleComponent($event)" >
                                            <nz-icon [nzType]="'clock-circle'" />
                                        </button>
                                    </nz-space-compact>
                                
                                </nz-form-control>
                        </nz-form-item>
                    </form>

                    <nz-collapse nzBordered="true" class="card-board" >
                        <nz-collapse-panel nzHeader="{{'agentBuilder.goal'|translateTA}}">
                            <nz-table [nzData]="form.get('goal').value" #tableGoal nzBordered nzSize="small">
                                <tbody>
                                    <tr *ngFor="let item of tableGoal.data; let i = index">
                                        <td (click)="editGoal(i)" style="cursor: pointer;">
                                            <ng-container *ngIf="editGoalIndex !== i; else editTpl">
                                            {{ item }}
                                            </ng-container>

                                            <ng-template #editTpl>
                                            <input
                                                nz-input
                                                [(ngModel)]="items[i]"
                                                (blur)="stopEditGoal()"
                                                (keyup.enter)="stopEditGoal()" />
                                            </ng-template>
                                        </td>
                                        <td style="width: 40px; text-align: center;">
                                            <button
                                            nz-button
                                            nzType="link"
                                            nzDanger
                                            (click)="removeGoal(i); $event.stopPropagation()">
                                            x
                                        </button>

                                    </tr>

                                    <!-- Linha para adicionar -->
                                    <tr>
                                        <td>
                                            <input
                                            nz-input
                                            placeholder="Adicionar..."
                                            [(ngModel)]="newGoalItem"
                                            (keyup.enter)="addGoal()" />
                                        </td>
                                    </tr>
                                </tbody>
                            </nz-table>
                        </nz-collapse-panel>
                    </nz-collapse>
                }
            
        }

        @if (passoAtual === 1) {
            
        @if (form.get('systemPromptHistory')?.value?.length > 0) {
            <div class="system-prompt-history">
                <nz-select class="system-prompt-history-select"
                    [(ngModel)]="historySelected"
                    ngModelOptions="{standalone: true}"
                    [nzPlaceHolder]="'agentBuilder.systemPromptHistory'|translateTA">
                    @for (history of form.get('systemPromptHistory')!.value; track $index; let i = $index) {
                        <nz-option 
                            [nzValue]="i" 
                            [nzLabel]="(fixDate(history.updatedAt) | date:'yyyy-MM-dd HH:mm:ss' )+' - '+history.userName">
                        </nz-option>
                    }
                </nz-select>

                    <button 
                            nz-button 
                            nzType="primary" 
                            (click)="selectHistoryPrompt();canRedoSystemPrompt=true"
                            style="margin-bottom: 16px">
                            {{'agentBuilder.selectPrompt'|translateTA}}
                    </button>
                </div>
            }
            
            @if ( !form.get('systemPrompt').pristine || canRedoSystemPrompt ){
                <button class="system-prompt-history-redo" nz-button nzType="text" nz-tooltip="{{ 'agentBuilder.redo' |translateTA }}" (click)="form.get('systemPrompt').setValue(backupSystemPrompt);canRedoSystemPrompt=false;form.get('systemPrompt').markAsPristine()" [disabled]="!canRedoSystemPrompt && form.get('systemPrompt').pristine">
                    <nz-icon nzType="redo" nzTheme="outline"></nz-icon>
                </button>
            }

            <form nz-form [formGroup]="form" nzLabelAlign="right" [nzLayout]="'vertical'">

                <!-- Construtor de prompt: alterna entre o prompt unico e as secoes -->
                <div class="prompt-builder-switch">
                    <nz-switch formControlName="usePromptBuilder" nzSize="small"></nz-switch>
                    <span class="prompt-builder-switch-label">{{'agentBuilder.usePromptBuilder'|translateTA}}</span>
                    <span class="prompt-builder-switch-hint">{{'agentBuilder.usePromptBuilder.hint'|translateTA}}</span>
                </div>

                @if ( !form.get('usePromptBuilder').value ) {
                    <nz-form-item>
                        <nz-form-label>{{'agentBuilder.systemprompt'|translateTA}}</nz-form-label>
                        <nz-form-control>
                            <div class="quill-container">
                                <quill-editor class="quill-container"  formControlName="systemPrompt" [format]="'html'" [styles]="{'min-height': (8 * 30) + 'px','width':'100%', 'height':'250px'}"></quill-editor>
                            </div>
                        </nz-form-control>
                    </nz-form-item>
                }

                @if ( form.get('usePromptBuilder').value ) {
                    <div class="prompt-builder-sections" formGroupName="promptBuilder">

                        <nz-alert nzType="info" nzShowIcon
                            [nzMessage]="'agentBuilder.promptBuilder.order'|translateTA"></nz-alert>

                        <nz-collapse>
                            @for ( secao of secoesDoPrompt; track secao.campo ) {
                                <nz-collapse-panel
                                    [nzHeader]="secao.titulo|translateTA"
                                    [nzExtra]="secaoPreenchidaTpl"
                                    [(nzActive)]="secao.aberta">

                                    <ng-template #secaoPreenchidaTpl>
                                        <nz-tag [nzColor]="temConteudo(secao.campo) ? 'green' : 'default'">
                                            {{ (temConteudo(secao.campo) ? 'agentBuilder.promptBuilder.filled' : 'agentBuilder.promptBuilder.empty')|translateTA }}
                                        </nz-tag>
                                    </ng-template>

                                    <p class="prompt-builder-section-hint">{{secao.ajuda|translateTA}}</p>

                                    @if ( secao.aberta ) {
                                        <div class="quill-container">
                                            <quill-editor class="quill-container"
                                                [formControlName]="secao.campo"
                                                [format]="'html'"
                                                [styles]="{'min-height': '150px','width':'100%','height':'180px'}"></quill-editor>
                                        </div>
                                    }
                                </nz-collapse-panel>
                            }
                        </nz-collapse>
                    </div>
                }
                <!-- O OrchestratorPromptBuilder acrescenta este texto no FIM do
                     prompt, nos dois modos (texto unico e construtor). Por vir
                     por ultimo, e o que mais pesa na resposta. -->
                <nz-form-item>
                    <nz-form-label>{{'agentBuilder.devprompt'|translateTA}}</nz-form-label>
                    <nz-form-control [nzExtra]="'agentBuilder.devprompt.hint'|translateTA">
                        <textarea nz-input rows="8" formControlName="devMessage"></textarea>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label>{{'agentBuilder.welcomemessage'|translateTA}}</nz-form-label>
                    <nz-form-control>
                        <textarea nz-input rows="8" formControlName="welcomeMessage"></textarea>
                    </nz-form-control>
                </nz-form-item>
            </form>
        }

        @if (passoAtual === 2) {
            <agent-builder-kb-upload [agent]="agent"></agent-builder-kb-upload>
        }

        @if (passoAtual === 3) {
            @if (agent?._id == null) {
                <nz-alert nzType="info" nzShowIcon
                    [nzMessage]="'agentBuilder.step.saveBeforeDictionary'|translateTA"></nz-alert>
            } @else {
                <agent-builder-dictionary [agent]="agent"
                    (curadoriaMudou)="dicionarioTemCuradoria = $event"></agent-builder-dictionary>
            }
        }

        @if (passoAtual === 4) {
            <div class="tab-container">
                <form nz-form [formGroup]="form" nzLabelAlign="right" nzLayout="vertical">
                    
                        <button 
                            nz-button 
                            nzType="primary" 
                            (click)="openAddMcpModal()"
                            style="margin-bottom: 16px">
                            + {{'agentBuilder.addmcp'|translateTA}}
                        </button>

                        <div class="tab-container">
                        <nz-table
                            nzBordered
                            [nzNoResult]="emptyTemplate"
                            [nzLoading]="mcpLoading"
                            [nzShowPagination]="true"
                            [(nzPageIndex)]="mcpPageIndex"
                            [nzPageSize]="3"
                            [nzData]="mcps"
                            [nzScroll]="{ y: 'calc(100vh - 390px)' }"
                            #tableMcp
                            class="full-table">

                            <thead>
                                <tr>
                                    <th>{{'agentBuilder.idhook'|translateTA}}</th>
                                    <th>{{'agentBuilder.url'|translateTA}}</th>
                                    <th>{{'agentBuilder.tools'|translateTA}}</th>
                                    <th>{{'agentBuilder.actions'|translateTA}}</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let group of tableMcp.data; let i = index" >
                                    <td>{{ group?.idhook?.key }} - {{ group?.idhook?.value }}</td>
                                    <td>{{ group?.url }}</td>
                                    <td>{{ getToolNames(group) }}</td>
                                    <td style="white-space: nowrap;">
                                        <button nz-button nzType="primary" nzSize="small" (click)="editMcp(i)" style="margin-right: 8px">
                                            {{'agentBuilder.edit'|translateTA}}
                                        </button>
                                        <button nz-button nzDanger nzSize="small" (click)="deleteMcp(i)">
                                            {{'agentBuilder.delete'|translateTA}}
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </nz-table>
                    
                </div>
                </form>
            </div>
        }

        @if (passoAtual === 5) {
            <agent-builder-subagents [agent]="agent" [form]="form" [variables]="variables"></agent-builder-subagents>
        }

        @if (passoAtual === 6) {
            @if (agent?._id == null) {
                <nz-alert nzType="info" nzShowIcon
                    [nzMessage]="'agentBuilder.step.saveBeforeTest'|translateTA"></nz-alert>
            } @else {
                <agent-builder-prompt [agent]="agent"></agent-builder-prompt>
            }
        }

        @if (passoAtual === 7) {
            @if (agent?._id == null) {
                <nz-alert nzType="info" nzShowIcon
                    [nzMessage]="'agentBuilder.step.saveBeforeHistory'|translateTA"></nz-alert>
            } @else {
                <nz-tabs>
                    <nz-tab nzTitle="{{'agentBuilder.messageLogTitle'|translateTA}}">
                        <agent-builder-messages-log [agent]="agent"></agent-builder-messages-log>
                    </nz-tab>
                    <nz-tab nzTitle="{{'agentBuilder.mcpLogTitle'|translateTA}}">
                        <agent-builder-mcp-log [agent]="agent"></agent-builder-mcp-log>
                    </nz-tab>
                </nz-tabs>
            }
        }

        @if (passoAtual === 8) {
            @if (agent?._id == null) {
                <nz-alert nzType="info" nzShowIcon
                    [nzMessage]="'agentBuilder.step.saveBeforeExecutions'|translateTA"></nz-alert>
            } @else if (form.get('autonomo')?.value !== true) {
                <!-- So o modo autonomo gera execucoes; num agente de conversa a
                     tela ficaria sempre vazia, sem explicar por que -->
                <nz-alert nzType="info" nzShowIcon
                    [nzMessage]="'agentBuilder.executions.onlyAutonomous'|translateTA"></nz-alert>
            } @else {
                <agent-builder-executions [agent]="agent"></agent-builder-executions>
            }
        }

        @if (passoAtual === 9) {
            @if (agent?._id == null) {
                <nz-alert nzType="info" nzShowIcon
                    [nzMessage]="'agentBuilder.step.saveBeforeCandidates'|translateTA"></nz-alert>
            } @else {
                <agent-builder-candidates [agent]="agent"></agent-builder-candidates>
            }
        }

    </div>

    </div><!-- fim do agente-layout -->

    <!-- Navegacao entre os passos -->
    <div class="passos-navegacao">
        <button nz-button nzType="default" (click)="passoAnterior()" [disabled]="passoAtual === 0">
            <nz-icon nzType="left"></nz-icon>
            {{'back'|translateTA}}
        </button>
        <button nz-button nzType="default" (click)="proximoPasso()" [disabled]="passoAtual === passos.length - 1">
            {{'next'|translateTA}}
            <nz-icon nzType="right"></nz-icon>
        </button>
    </div>
    <button nz-button nzType="primary" (click)="save()" class="salvar-agent-button" *ngIf="showSaveButton">Salvar Agente</button>
</nz-card>

<!-- Modal para adicionar/editar MCP -->
<nz-modal
  [(nzVisible)]="showMcpModal"
  [nzTitle]="editingIndexMcp>-1 ? ('agentBuilder.editmcp'|translateTA) : ('agentBuilder.addmcp'|translateTA)"
  nzOkText="{{'agentBuilder.save'|translateTA}}"
  nzCentered="true"
  nzCancelText="{{'agentBuilder.cancel'|translateTA}}"
  nzWidth="80vw"
  nzHeight="95vh"
  (nzOnOk)="saveMcp()"
  (nzOnCancel)="closeMcpModal()">
    <ng-container *nzModalContent>
        <form nz-form [formGroup]="mcpForm">
            <nz-form-item>
                <nz-form-label>{{'agentbuilder.localmcp' | translateTA}}</nz-form-label>
                <nz-form-control>
                    <nz-switch formControlName="local"></nz-switch>
                </nz-form-control>    
            </nz-form-item>
            <nz-divider nzPlain nzVariant="solid"  style="background-color: rgb(220, 220, 220);" ></nz-divider>
            @if( switchValueMCPMode ){
                <nz-form-item>
                    <nz-form-label>{{'agentbuilder.idhook' | translateTA}}</nz-form-label>
                    <nz-form-control>
                        <search-input-new [searchProperties]="searchWebHook" class="full-width" formControlName="idhook"
                        #searchInputIdhook
                        (onChangeData)="onChangeTools($event)"
                        ></search-input-new>
                    </nz-form-control>
                </nz-form-item>
            }@else{
                <nz-form-item>
                    <nz-form-label>URL</nz-form-label>
                    <nz-form-control nzErrorTip="{{'agentBuilder.urlrequired'|translateTA}}">
                        <input 
                        nz-input 
                        formControlName="url" 
                        placeholder="http://localhost:3000">
                    </nz-form-control>
                </nz-form-item>
            }
            
            <nz-form-item>
                <nz-form-label>{{'agentBuilder.tools'|translateTA}}</nz-form-label>
                <div class="item-form-group">
                    <nz-form-control>
                        <nz-select 
                            [compareWith]="compareTools"
                            formControlName="tools" 
                            nzMode="multiple"
                            nzPlaceHolder="{{'agentBuilder.selecttools'|translateTA}}">
                            <nz-option *ngFor="let tool of filteredListOfTool[0]?.tools" [nzValue]="tool" [nzLabel]="(tool.name==null?tool:tool.name) + (tool.description ? ' - ' + tool.description : '')"></nz-option>
                        </nz-select>
                    </nz-form-control>
                    <button nz-button nzType="primary" nzSize="small" (click)="loadMcpTools()" [nzLoading]="loadingMcp" *ngIf="!switchValueMCPMode">
                        {{'agentBuilder.finddata'|translateTA}}
                    </button>
                </div>
            </nz-form-item>
            <nz-form-item *ngIf="!switchValueMCPMode">
                <nz-form-label>{{'agentBuilder.header'|translateTA}}</nz-form-label>
                <nz-table [nzData]="mcpForm.get('header')?.value || []" nzBordered #tableHHeader class="tab-container" [nzScroll]="{ y: 'calc(100vh - 500px)' }">
                    <thead>
                        <tr>
                            <th>Chave</th>
                            <th>Valor</th>
                            <th style="width: 80px;">{{'agentBuilder.actions'|translateTA}}</th>
                        </tr>
                    </thead>
                     
                    <tbody>
                        <tr class="row-insert-table">
                            <td>
                                <input nz-input placeholder="{{'agentBuilder.newKey'|translateTA}}"  [(ngModel)]="newKey" [ngModelOptions]="{standalone: true}"/>
                            </td>
                            <td>
                                <input nz-input placeholder="{{'agentBuilder.newKey'|translateTA}}" [(ngModel)]="newValue" [ngModelOptions]="{standalone: true}"/>
                            </td>
                            <td>
                                <button nz-button nzType="primary" nzSize="small" (click)="addHeader()">
                                    {{'agentBuilder.add'|translateTA}}
                                </button>
                            </td>
                        </tr>
                        <tr *ngFor="let item of tableHHeader.data; let i = index">
                            <td>
                                <input
                                nz-input
                                [(ngModel)]="item.key"
                                [ngModelOptions]="{standalone: true}"
                                />
                            </td>

                            <td>
                                <input
                                nz-input
                                [(ngModel)]="item.value"
                                [ngModelOptions]="{standalone: true}"
                                />
                            </td>

                            <td>
                                <button nz-button nzDanger nzSize="small" (click)="removeHeader(i)">
                                    {{'agentBuilder.remove'|translateTA}}
                                </button>
                            </td>
                        </tr>
                       
                    </tbody>
                </nz-table>
            </nz-form-item>
        </form>
    </ng-container>
</nz-modal>

<ng-template #cardExitTemplate>
    <button nz-button nzType="default" nzShape="circle" (click)="closeConfig()">
        <nz-icon  nzType="close" nzTheme="outline"  />
    </button>
    
</ng-template>

<ng-template #emptyTemplate >
           <nz-empty 
              nzNotFoundContent="Nenhum mcp adicionado"
              style="margin: 0">
            </nz-empty>
</ng-template>